"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isTemplateId = exports.TEMPLATE_IDS = exports.POLL_POST_TEMPLATE_IDS = void 0;
exports.POLL_POST_TEMPLATE_IDS = [
    'poll-thisorthat-medium',
    'poll-thisorthat-large',
    'poll-voteslider-medium',
    'poll-voteslider-large',
    'poll-multichoice-medium',
    'poll-multichoice-large',
];
exports.TEMPLATE_IDS = [
    'article-interactive-medium',
    'article-interactive-large',
    'article-static-medium',
    'article-static-large',
    'link-shop-medium',
    'link-shop-large',
    'link-storefront-medium',
    'link-storefront-large',
    'link-medium',
    'link-large',
    'video-medium',
    'video-large',
    'tile-puzzle-large',
    'event-calendar-small',
    'event-calendar-medium',
    ...exports.POLL_POST_TEMPLATE_IDS,
];
const isTemplateId = (value) => {
    return exports.TEMPLATE_IDS.some((id) => id === value);
};
exports.isTemplateId = isTemplateId;
